import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingQuery } from '../../state/loading/loading.query';
import { SettingsQuery } from '../../state/settings/settings.query';

@Component({
    standalone: false,
    selector: 'app-loading-screen',
    templateUrl: './loading-screen.component.html',
    styleUrls: ['./loading-screen.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingScreenComponent {
    /**
     * Se exponen como observables y se consumen con `async` en el template.
     * fixea error de NG0100 por angular 21
     */
    isLoadingActive$: Observable<boolean> = this.loadingQuery.select('active');
    showSpinner$: Observable<boolean> = this.loadingQuery.select('showSpinner');
    browser$: Observable<boolean> = this.settingsQuery.select('browser');

    constructor(
        private loadingQuery: LoadingQuery,
        private settingsQuery: SettingsQuery
    ) {}
}
